import React from 'react';
import Form from 'react-bootstrap/Form';

export default class FlowFieldHidden extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { field, id, updateValue, inputType } = this.props;
        const { label, required, disabled, value } = field;

        return (
            <Form.Control
                className={``}
                placeholder={label}
                id={id}
                name={id}
                type={inputType}
                {...{
                    required,
                    disabled,
                }}
                value={value || ''}
                onChange={(e) => updateValue(e.target.value)}
            />
        );
    }
}
